import React, { useEffect } from "react";
import "./Genius.css";
import { Button } from "react-bootstrap";
import Modal from "../Modals/EmbedSafeModal";

export const Genius = ({
  setOpenGeniusModal,
  getGeniusChallenge,
  openGeniusModal,
  handleGeniusModalClose,
  geniusPurchaseEnabled,
}) => {
  return (
    <Modal
      centered
      show={openGeniusModal}
      onHide={handleGeniusModalClose}
      className="genius-modal"
      loading="lazy"
    >
      <Modal.Header className="genius-header">
        <span
          onClick={handleGeniusModalClose}
          className="close-button-yesterdayansw"
        >
          &times;
        </span>
      </Modal.Header>
      <Modal.Body className="genius-body">
        <div className="genius-body-content">
          {!geniusPurchaseEnabled ? (
            <span>
              Get more advanced Genius challenges!
              <br />
              Watch an ad and get it for free.
            </span>
          ) : (
            <span>
              Speel extra moeijlijke
              <br />
              genius challenges!
            </span>
          )}
          {!geniusPurchaseEnabled ? (
            <Button
              onClick={() => {
                getGeniusChallenge();
              }}
            >
              Get a Genius challenge
            </Button>
          ) : (
            <div className="genius-prices">
              <div
                className="first-price"
                onClick={() => {
                  getGeniusChallenge();
                }}
              >
                <span>€ 0,99</span>
                <p>3 x genius</p>
              </div>
              <div
                className="second-price"
                onClick={() => {
                  getGeniusChallenge();
                }}
              >
                <span>€ 2,50</span>
                <p>10 x genius</p>
              </div>
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};
